import {
  ErrorPageMessage,
  ErrorPageWrapper,
} from './IdentificationRequests.styles';

const IdentificationRequestsError = ({ message }: { message: string }) => {
  return (
    <ErrorPageWrapper>
      <ErrorPageMessage>{message}</ErrorPageMessage>
    </ErrorPageWrapper>
  );
};

export { IdentificationRequestsError };
